(() => {
  const theme = window.theme || {}
  const routes = theme.routes || {}
  const $ = (sel, root = document) => root.querySelector(sel)
  const $$ = (sel, root = document) => [...root.querySelectorAll(sel)]
  const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches

  const safe = (label, fn) => {
    try {
      fn()
    } catch (error) {
      console.error(`[theme] ${label}`, error)
      document.querySelectorAll(".reveal").forEach((el) => el.classList.add("is-visible"))
    }
  }

  /* ---------- Reveal on scroll ---------- */
  safe("Reveal on scroll", () => {
  const revealIO = new IntersectionObserver(
    (entries) =>
      entries.forEach((e) => {
        if (!e.isIntersecting) return
        e.target.classList.add("is-visible")
        revealIO.unobserve(e.target)
      }),
    { threshold: 0.15 }
  )
  $$(".reveal").forEach((el) => revealIO.observe(el))
  })

  /* Money: Shopify money_format, e.g. "{{amount_with_comma_separator}} zł" (cents in). */
  function formatMoney(cents) {
    const format = theme.moneyFormat || "{{amount}}"
    const value = Number(cents) / 100
    const group = (n, decimals, thousands, decimal) => {
      const [int, frac] = n.toFixed(decimals).split(".")
      const withSep = int.replace(/\B(?=(\d{3})+(?!\d))/g, thousands)
      return frac ? withSep + decimal + frac : withSep
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case "amount_no_decimals":
          return group(value, 0, ",", ".")
        case "amount_with_comma_separator":
          return group(value, 2, ".", ",")
        case "amount_no_decimals_with_comma_separator":
          return group(value, 0, ".", ",")
        case "amount_with_space_separator":
          return group(value, 2, " ", ",")
        case "amount_with_apostrophe_separator":
          return group(value, 2, "'", ".")
        default:
          return group(value, 2, ",", ".")
      }
    })
  }

  /* ---------- Cart ---------- */
  const drawer = $("#cart-drawer")
  let cartBusy = false

  async function cartRequest(url, body) {
    const res = await fetch(url, {
      method: body ? "POST" : "GET",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: body ? JSON.stringify(body) : undefined,
    })
    const data = await res.json().catch(() => null)
    if (!res.ok) throw new Error((data && (data.description || data.message)) || "Cart error")
    return data
  }

  const getCart = () => cartRequest(`${routes.cart}.js`)

  function updateCount(count) {
    $$("[data-cart-count]").forEach((el) => {
      el.textContent = count
      el.classList.toggle("hidden", count === 0)
    })
    $$("[data-cart-open]").forEach((el) => {
      const t = el.dataset.labelTemplate
      if (t) el.setAttribute("aria-label", t.replace("%COUNT%", count))
    })
  }

  function sizedImage(url, width) {
    if (!url) return ""
    return url + (url.includes("?") ? "&" : "?") + `width=${width}`
  }

  function renderCart(cart) {
    updateCount(cart.item_count)
    if (!drawer) return
    const list = $("[data-cart-lines]", drawer)
    const tpl = $("#cart-line-template", drawer)
    const empty = cart.item_count === 0
    $("[data-cart-empty]", drawer).classList.toggle("hidden", !empty)
    list.classList.toggle("hidden", empty)
    $("[data-cart-footer]", drawer).classList.toggle("hidden", empty)
    $("[data-cart-footer]", drawer).classList.toggle("flex", !empty)
    $("[data-cart-subtotal]", drawer).textContent = formatMoney(cart.items_subtotal_price ?? cart.total_price)
    list.replaceChildren(
      ...cart.items.map((item) => {
        const node = tpl.content.firstElementChild.cloneNode(true)
        $$("[data-line-link]", node).forEach((a) => (a.href = item.url))
        const img = $("[data-line-image]", node)
        if (item.image) img.src = sizedImage(item.image, 160)
        else img.remove()
        $("[data-line-title]", node).textContent = item.product_title
        $("[data-line-variant]", node).textContent = item.product_has_only_default_variant ? "" : item.variant_title
        $("[data-line-total]", node).textContent = formatMoney(item.final_line_price)
        $("[data-line-quantity]", node).textContent = item.quantity
        const change = (q) => changeLine(item.key, q)
        $("[data-line-decrease]", node).addEventListener("click", () => change(item.quantity - 1))
        $("[data-line-increase]", node).addEventListener("click", () => change(item.quantity + 1))
        $("[data-line-remove]", node).addEventListener("click", () => change(0))
        return node
      })
    )
  }

  function setDrawerBusy(busy) {
    cartBusy = busy
    if (!drawer) return
    $$("[data-line-decrease],[data-line-increase],[data-line-remove]", drawer).forEach((b) => (b.disabled = busy))
  }

  function showCartError(show) {
    const el = drawer && $("[data-cart-error]", drawer)
    if (el) el.classList.toggle("hidden", !show)
  }

  async function changeLine(key, quantity) {
    if (cartBusy) return
    setDrawerBusy(true)
    showCartError(false)
    try {
      renderCart(await cartRequest(`${routes.cartChange}.js`, { id: key, quantity: Math.max(0, quantity) }))
    } catch {
      showCartError(true)
    } finally {
      setDrawerBusy(false)
    }
  }

  function openDrawer() {
    if (!drawer || drawer.open) return
    drawer.showModal()
    document.dispatchEvent(new CustomEvent("cart:toggle", { detail: { open: true } }))
  }
  function closeDrawer() {
    if (drawer && drawer.open) drawer.close()
  }

  async function addToCart(id, quantity = 1) {
    await cartRequest(`${routes.cartAdd}.js`, { items: [{ id: Number(id), quantity: Number(quantity) || 1 }] })
    renderCart(await getCart())
    openDrawer()
  }

  if (drawer) {
    drawer.addEventListener("close", () => document.dispatchEvent(new CustomEvent("cart:toggle", { detail: { open: false } })))
    drawer.addEventListener("click", (e) => {
      if (e.target === drawer) closeDrawer()
    })
    $$("[data-cart-close]", drawer).forEach((b) => b.addEventListener("click", closeDrawer))
    $$("[data-cart-open]").forEach((a) =>
      a.addEventListener("click", (e) => {
        e.preventDefault()
        openDrawer()
      })
    )
    getCart().then(renderCart).catch(() => {})
  }

  /* ---------- Buy box (variants, price, add to cart) ---------- */
  const buyBoxes = new Map()

  function setupBuyBox(box) {
    const id = box.dataset.buyBox
    const variants = JSON.parse($("[data-variants]", box).textContent)
    const form = $("form.js-buy-form", box) || document.getElementById(id)
    if (!form) return
    const input = $("[data-variant-input]", form)
    const cta = $("[data-buy-cta]", form)
    const label = $("[data-cta-label]", cta)
    const ctaPrice = $("[data-cta-price]", cta)
    const bestId = box.dataset.bestId
    const listeners = new Set()
    let current = variants.find((v) => String(v.id) === input.value) || variants[0]

    function render() {
      const v = current
      $("[data-price]", box).textContent = formatMoney(v.price)
      const compare = $("[data-compare]", box)
      compare.textContent = v.compare > v.price ? formatMoney(v.compare) : ""
      compare.classList.toggle("hidden", !(v.compare > v.price))
      const saving = $("[data-saving]", box)
      const pct = v.compare > v.price ? Math.round((1 - v.price / v.compare) * 100) : 0
      saving.textContent = saving.dataset.template.replace("%PCT%", pct)
      saving.classList.toggle("hidden", pct === 0)
      const unit = $("[data-unit]", box)
      if (v.count > 1) {
        unit.textContent =
          unit.dataset.template.replace("%PRICE%", formatMoney(Math.round(v.price / v.count))) +
          (String(v.id) === bestId ? ` · ${unit.dataset.best}` : "")
      }
      unit.classList.toggle("hidden", !(v.count > 1))
      cta.disabled = !v.available
      label.textContent = v.available ? cta.dataset.labelAdd : cta.dataset.labelSoldout
      if (ctaPrice) ctaPrice.textContent = `· ${formatMoney(v.price)}`
      input.value = v.id
      $$("[data-variant-radio]", box).forEach((r) => (r.checked = r.value === String(v.id)))
      listeners.forEach((fn) => fn(v))
    }

    function select(variantId) {
      const next = variants.find((v) => String(v.id) === String(variantId))
      if (!next) return
      current = next
      render()
      const url = new URL(window.location.href)
      if (document.body.contains($("[data-gallery]"))) {
        url.searchParams.set("variant", next.id)
        history.replaceState(null, "", url)
      }
    }

    $$("[data-variant-radio]", box).forEach((r) => r.addEventListener("change", () => select(r.value)))

    const qty = $("[data-qty-input]", form)
    if (qty) {
      $("[data-qty-decrease]", form).addEventListener("click", () => (qty.value = Math.max(1, (Number(qty.value) || 1) - 1)))
      $("[data-qty-increase]", form).addEventListener("click", () => (qty.value = Math.min(99, (Number(qty.value) || 1) + 1)))
    }

    async function add(quantity) {
      if (!current.available) return false
      cta.disabled = true
      label.textContent = cta.dataset.labelAdding
      try {
        await addToCart(current.id, quantity)
        label.textContent = cta.dataset.labelAdded
        return true
      } catch {
        label.textContent = cta.dataset.labelAdd
        form.submit()
        return false
      } finally {
        cta.disabled = !current.available
      }
    }

    form.addEventListener("submit", (e) => {
      e.preventDefault()
      add(qty ? qty.value : 1)
    })

    const api = {
      cta,
      get current() {
        return current
      },
      select,
      add,
      onChange: (fn) => listeners.add(fn),
    }
    buyBoxes.set(id, api)
  }

  $$("[data-buy-box]").forEach((box) => safe("buy box", () => setupBuyBox(box)))

  /* ---------- Sticky add-to-cart bar (mobile) ---------- */
  safe("Sticky add-to-cart bar (mobile)", () => {
  $$("[data-sticky-bar]").forEach((bar) => {
    const box = buyBoxes.get(bar.dataset.stickyBar)
    if (!box) return
    const select = $("[data-sticky-select]", bar)
    const price = $("[data-sticky-price]", bar)
    const compare = $("[data-sticky-compare]", bar)
    const button = $("[data-sticky-add]", bar)
    let ctaVisible = true
    let cartOpen = false

    const sync = (v) => {
      select.value = String(v.id)
      price.textContent = formatMoney(v.price)
      compare.textContent = v.compare > v.price ? formatMoney(v.compare) : ""
      compare.classList.toggle("hidden", !(v.compare > v.price))
      button.disabled = !v.available
    }
    const update = () => {
      const show = !ctaVisible && !cartOpen
      bar.dataset.visible = String(show)
      bar.inert = !show
    }
    box.onChange(sync)
    sync(box.current)
    select.addEventListener("change", () => box.select(select.value))
    button.addEventListener("click", () => box.add(1))
    new IntersectionObserver(([entry]) => {
      ctaVisible = entry.isIntersecting
      update()
    }).observe(box.cta)
    document.addEventListener("cart:toggle", (e) => {
      cartOpen = e.detail.open
      update()
    })
  })
  })

  /* ---------- Quick add (bundle cards) ---------- */
  safe("Quick add (bundle cards)", () => {
  $$("form.js-quick-add").forEach((form) => {
    const button = $("button[type=submit]", form)
    form.addEventListener("submit", async (e) => {
      e.preventDefault()
      button.disabled = true
      try {
        await addToCart(new FormData(form).get("id"), 1)
        button.textContent = button.dataset.labelAdded
      } catch {
        form.submit()
      } finally {
        button.disabled = false
      }
    })
  })
  })

  /* ---------- Header ---------- */
  safe("Header", () => {
  const header = $("[data-header]")
  if (header) {
    const menu = $("#mobile-menu")
    const toggle = $("[data-menu-toggle]")
    const setMenu = (open) => {
      menu.dataset.open = String(open)
      menu.inert = !open
      toggle.setAttribute("aria-expanded", String(open))
      toggle.setAttribute("aria-label", open ? toggle.dataset.labelClose : toggle.dataset.labelOpen)
      $("[data-menu-icon-open]", toggle).classList.toggle("hidden", open)
      $("[data-menu-icon-close]", toggle).classList.toggle("hidden", !open)
      updateSolid()
    }
    const updateSolid = () => {
      header.dataset.solid = String(window.scrollY > 24 || menu.dataset.open === "true")
    }
    toggle.addEventListener("click", () => setMenu(menu.dataset.open !== "true"))
    $$("[data-menu-link]", menu).forEach((a) => a.addEventListener("click", () => setMenu(false)))
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && menu.dataset.open === "true") {
        setMenu(false)
        toggle.focus()
      }
    })
    window.addEventListener("scroll", updateSolid, { passive: true })
    updateSolid()

    const links = $$("[data-nav-link]", header)
    const targets = links
      .map((a) => {
        const hash = new URL(a.href, window.location.href).hash
        return hash ? [a, document.getElementById(hash.slice(1))] : null
      })
      .filter((pair) => pair && pair[1])
    if (targets.length) {
      const io = new IntersectionObserver(
        (entries) => {
          const visible = entries.find((e) => e.isIntersecting)
          if (!visible) return
          targets.forEach(([a, section]) => a.setAttribute("aria-current", String(section === visible.target)))
        },
        { rootMargin: "-45% 0px -50% 0px" }
      )
      targets.forEach(([, section]) => io.observe(section))
    }

    const search = $("#search-dialog")
    $("[data-search-open]", header)?.addEventListener("click", () => {
      search.showModal()
      $("input[type=search]", search).focus()
    })
    $("[data-search-close]", search)?.addEventListener("click", () => search.close())
    search?.addEventListener("click", (e) => {
      if (e.target === search) search.close()
    })
  }
  })

  /* ---------- Count-up numbers ---------- */
  safe("Count-up numbers", () => {
  $$("[data-stats]").forEach((list) => {
    const items = $$("[data-count-to]", list)
    const nf = (d) => new Intl.NumberFormat("pl-PL", { minimumFractionDigits: d, maximumFractionDigits: d })
    const paint = (p) =>
      items.forEach((el) => {
        const d = Number(el.dataset.decimals) || 0
        const to = Number(String(el.dataset.countTo).replace(",", ".")) || 0
        el.textContent = `${el.dataset.prefix}${nf(d).format(to * p)}${el.dataset.suffix}`
      })
    const io = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) return
        io.disconnect()
        if (reducedMotion) return paint(1)
        const start = performance.now()
        const tick = (now) => {
          const t = Math.min(1, (now - start) / 1400)
          paint(1 - (1 - t) ** 3)
          if (t < 1) requestAnimationFrame(tick)
        }
        requestAnimationFrame(tick)
      },
      { threshold: 0.4 }
    )
    io.observe(list)
  })
  })

  /* ---------- Reviews carousel ---------- */
  safe("Reviews carousel", () => {
  $$("[data-carousel]").forEach((root) => {
    const track = $("[data-carousel-track]", root)
    const slides = [...track.children]
    const dots = $$("[data-carousel-dot]", root)
    let index = 0
    let paused = false
    const go = (i) => {
      index = (i + slides.length) % slides.length
      track.style.transform = `translateX(-${index * 100}%)`
      slides.forEach((s, n) => {
        s.inert = n !== index
        s.setAttribute("aria-hidden", String(n !== index))
      })
      dots.forEach((d, n) => d.setAttribute("aria-current", String(n === index)))
    }
    $("[data-carousel-prev]", root)?.addEventListener("click", () => go(index - 1))
    $("[data-carousel-next]", root)?.addEventListener("click", () => go(index + 1))
    dots.forEach((d) => d.addEventListener("click", () => go(Number(d.dataset.carouselDot))))
    ;["mouseenter", "focusin"].forEach((ev) => root.addEventListener(ev, () => (paused = true)))
    ;["mouseleave", "focusout"].forEach((ev) => root.addEventListener(ev, () => (paused = false)))
    go(0)
    if (slides.length > 1 && !reducedMotion) setInterval(() => !paused && go(index + 1), 7000)
  })
  })

  /* ---------- Product gallery ---------- */
  safe("Product gallery", () => {
  $$("[data-gallery]").forEach((root) => {
    const strip = $("[data-gallery-strip]", root)
    const counter = $("[data-gallery-counter]", root)
    const dots = $$("[data-gallery-dot]", root)
    const total = dots.length
    const markDots = (i) => dots.forEach((d, n) => d.setAttribute("aria-current", String(n === i)))
    if (strip) {
      strip.addEventListener(
        "scroll",
        () => {
          const i = Math.round(strip.scrollLeft / strip.clientWidth)
          if (counter) counter.textContent = `${i + 1} / ${total}`
          markDots(i)
        },
        { passive: true }
      )
      dots.forEach((d) =>
        d.addEventListener("click", () =>
          strip.scrollTo({ left: Number(d.dataset.galleryDot) * strip.clientWidth, behavior: reducedMotion ? "auto" : "smooth" })
        )
      )
    }
    const mains = $$("[data-gallery-main]", root)
    const thumbs = $$("[data-gallery-thumb]", root)
    thumbs.forEach((t) =>
      t.addEventListener("click", () => {
        const i = t.dataset.galleryThumb
        mains.forEach((m) => {
          const show = m.dataset.galleryMain === i
          m.classList.toggle("hidden", !show)
          if (show) $$("img", m).forEach((img) => (img.loading = "eager"))
        })
        thumbs.forEach((x) => x.setAttribute("aria-current", String(x === t)))
      })
    )
    if (mains[0]) $$("img", mains[0]).forEach((img) => (img.loading = "eager"))
  })
  })

})()
